import styled from 'styled-components'
import theme from '../../styles/theme'
export const CardContainer = styled.div``
export const ImgWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background: ${({ haveButtons }) => (haveButtons ? '#00698f' : 'none')};
`
export const Img = styled.img``

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;s
`

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${theme.color.black};
  padding: 1.5rem 1.5rem 0.5rem 1.5rem;
`

export const CardText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${theme.color.black};
  padding: 0.5rem 1.5rem 0.5rem 1.5rem;
`

export const RadioButtonWrapper = styled.div`
  padding: 0.5rem 1.5rem 1rem 1.5rem;
`

export const RadioButton = styled.input`
  color: ${theme.color.black};
`
